import DOMPurify from 'dompurify';

function addHrefTargetHook() {
  // Take from https://github.com/cure53/DOMPurify/blob/master/demos/hooks-target-blank-demo.html
  // Add a hook to make all links open a new window
  DOMPurify.addHook('afterSanitizeAttributes', (node: Element) => {
    // set all elements owning target to target=_blank
    if ('target' in node) {
      node.setAttribute('target', '_blank');
    }
    // set non-HTML/MathML links to xlink:show=new
    if (
      !node.hasAttribute('target') &&
      (node.hasAttribute('xlink:href') || node.hasAttribute('href'))
    ) {
      node.setAttribute('xlink:show', 'new');
    }
  });
}

export function replaceCidLinks(
  link: string,
  replacer: (imageName: string) => string,
): string {
  return link.replace(/cid:([^ @]+)(?:@.+)?/, (_, imageName) =>
    replacer(imageName),
  );
}

export function createImageLinksHook(imageReplacer: (src: string) => string) {
  return (node: Element) => {
    if (node.tagName === 'IMG' && node.hasAttribute('src')) {
      const imgSrc = node.getAttribute('src');
      if (imgSrc) {
        const newImgSrc = imageReplacer(imgSrc);
        node.setAttribute('src', newImgSrc);
      }
    }
  };
}

function addImageHook(imageReplacer: (src: string) => string) {
  DOMPurify.addHook(
    'afterSanitizeAttributes',
    createImageLinksHook(imageReplacer),
  );
}

function prepareDomPurifyHooks(imageReplacer: (src: string) => string) {
  DOMPurify.removeAllHooks();
  if (imageReplacer) {
    addImageHook(imageReplacer);
  }

  addHrefTargetHook();
}

export default function sanitizeForReact(
  imageReplacer: (src: string) => string,
  content: string,
): { __html: string } {
  /* DOMPurify uses global configuration. We need to customize it on each run, so we are going to prepare it before each run to ensure the correct config is being used. */
  prepareDomPurifyHooks(imageReplacer);
  return { __html: DOMPurify.sanitize(content) };
}
